import { ComponentResource, DesignResource } from '@/api/serverApi'
import { createContext, Dispatch, SetStateAction } from 'react'
import { LoadTypes } from '../components/LoadTypeForm'

type DesignResourceWithComponents = DesignResource & {
  components: ComponentResource[]
}

type LoadsContextProps = {
  design: DesignResourceWithComponents | undefined
  loadType: LoadTypes | undefined
  setLoadType: Dispatch<SetStateAction<LoadTypes>> | undefined
}

export const LoadsContext = createContext<LoadsContextProps>({
  design: undefined,
  loadType: undefined,
  setLoadType: undefined,
})
